
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import { jaJP } from '@mui/x-data-grid'
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp'
import { addDays, format } from 'date-fns'
import Header from '../../components/Header'
import Frame from '../../components/uiParts/Frame'
import TitleBar from '../../components/uiParts/TitleBar'
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid'
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm'
import { useAuth } from '../../contexts/AuthContext'
import { usePost } from './../../apis/ApiRequests'
import { dateToString } from '../../utils/Library'
import CustomCheckbox from '../../components/input/CustomCheckbox'
import CustomConfirm from '../../components/confirm/CustomConfirm'
import CustomSnackBar from '../../components/alert/CustomSnackBar'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

const BidGroup = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
	// initialize - 基本情報を設定
	//-----------------------------------------------
	const { authInfo }    = useAuth()
	const facilityCode    = authInfo.facilityCode
	const facilityName    = authInfo.facilityName
	const userId          = authInfo.userId
	const luserName       = authInfo.userName
	const authority       = authInfo.authority
	const today           = format(addDays(new Date(), 0), 'yyyy-MM-dd')   
	const authorityHeight = authority == 3 ? `${window.innerHeight - 220}px` : '220px'
	const navigate        = useNavigate()
    
    const title = authority == 3 ? '入札情報' : '入札管理'
    
	//-----------------------------------------------
	// initialize - useState
	//-----------------------------------------------
	const [ entryDate,      setEntryDate      ] = useState(today)
	const [ condition ,     setCondition      ] = useState('')
	const [ searchStatus ,  setSearchStatus   ] = useState(1)
	const [ searchCount,    setSearchCount    ] = useState(0)
	const [ bidList,        setBidList        ] = useState([])
	const [ bidGroupList,   setBidGroupList   ] = useState([])
	const [ dataGridHeight, setDataGridHeight ] = useState(window.innerHeight - 530)
	const [ checkedBidList, setCheckedBidList ] = useState([])
	const [ bidGroupNo ,    setBidGroupNo     ] = useState('')
    const [ requireMessage, setRequireMessage ] = useState('')
    const [ openRequire,    setOpenRequire    ] = useState(false)
    
    const [ registerData,   setRegisterData   ] = useState([])
    const [ prevBidDate_1 , setPrevBidDate_1  ] = useState('')
    const [ prevBidDate_2 , setPrevBidDate_2  ] = useState('')
    const [ isLoading,      setIsLoading      ] = useState(false)

    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue   : false,
        snackBarFalse  : false,
        require        : false,
        confirm        : false,
        confirm_common : false
    })
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
	// API - searchData / BidGroup
	//-----------------------------------------------
	const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost()
	const searchData = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate,
            'keyword2'     : condition,
            'keyword3'     : searchStatus
        }
        await searchData_post(postData)
	}
	//-----------------------------------------------
    // API - getGroupNo / BidGroup
	//-----------------------------------------------
    const { response : getNextNo_res, post : getNextNo_post } = usePost()
    const getNextNo = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : 'getNextNo',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getNextNo_post(postData)
    }
	//-----------------------------------------------
    // API - setData / BidGroup
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost()
    const setData = async (bidGroupNo) => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'       : 'mch.models.table.BidGroup',
            'methodName'      : 'setData',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'activeFlag'      : 1,
            'userId'          : userId,
            'bidGroupNo'      : bidGroupNo,
            'entryDate'       : numericDate,
            'senmeiGroupCode' : registerData.senmeiGroupCode,
            'senmeiGroup'     : registerData.senmeiGroup,
            'senmeiCode'      : registerData.senmeiCode,
            'senmei'          : registerData.senmei,
            'gyoshuCode'      : registerData.gyoshuCode,
            'gyoshu'          : registerData.gyoshu,
            'kgKubun'         : registerData.kgKubun,
            'nisugata'        : registerData.nisugata,
            'kikakuCode'      : registerData.kikakuCode,
            'kikaku'          : registerData.kikaku,
            'kgSuryo'         : registerData.kgSuryo,
            'yokiCode'        : registerData.yokiCode,
            'yoki'            : registerData.yoki,
            'suryo'           : registerData.suryo,
            'groupStatus'     : 1,
            'bidMode'         : registerData.bidMode,
        }
        await setData_post(postData)
    }
	//-----------------------------------------------
    // API - searchDataNoGroup / BidList
	//-----------------------------------------------
    const { response : searchData_bidList_res, loading : searchData_bidList_Loading, post:searchData_bidList_post } = usePost()
    const searchData_bidList = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'searchDataNoGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate
        }
        await searchData_bidList_post(postData)
    }
	//-----------------------------------------------
    // API - updateInBidGroup / BidList
	//-----------------------------------------------
    const { response : updateInBidGroup_res, post:updateInBidGroup_post } = usePost()
    const updateInBidGroup = async (bidGroupNo, uniqueId) => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'updateInBidGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'uniqueId'     : uniqueId,
            'bidGroupNo'   : bidGroupNo,
            'bidStatus'    : 1
        }
        await updateInBidGroup_post(postData)
    }
	//-----------------------------------------------
    // API - 過去入札日の参照
	//-----------------------------------------------
    const { response : getPrevBidDate_res, post:getPrevBidDate_post } = usePost()
    const getPrevBidDate = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getPrevBidDate',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getPrevBidDate_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        getPrevBidDate()
        setSearchCount(searchCount+1)
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 530)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
        
    },[])
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData()
        searchData_bidList()
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / BidGroup)
	//-----------------------------------------------
    useEffect(() => {
        setBidGroupList([])
        if (searchData_res) {
            setBidGroupList(searchData_res.Data)
        }
    }, [searchData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextNo / BidGroup)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextNo_res) {
            setBidGroupNo('')
            setBidGroupNo(getNextNo_res.bidGroupNo)
            setData(getNextNo_res.bidGroupNo)

            setMessageInfo('confirm', false)
            setMessageInfo('confirm_common', false)
            setMessageInfo('snackBarTrue', true)

            setIsLoading(false)
        }
    }, [getNextNo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / BidGroup)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            checkedBidList.map(async (checkedBidListId) => {
                bidList.map(item => {
                    let bidData = {}
                    if (item.id == checkedBidListId) { 
                        bidData = item
                        updateInBidGroup(getNextNo_res.bidGroupNo, bidData.uniqueId)
                    }
                })
            })
        }
    }, [setData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchDataNoGroup / BidList)
	//-----------------------------------------------
    useEffect(() => {
        setBidList([])
        if (searchData_bidList_res) {
            setBidList(searchData_bidList_res.Data)
        }
    }, [searchData_bidList_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(updateInBidGroup / BidList)
	//-----------------------------------------------
    useEffect(() => {
        if (updateInBidGroup_res) {
            setCheckedBidList([])
            setSearchCount(searchCount + 1)
        }
    }, [updateInBidGroup_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getPrevBidDate / bidList)
	//-----------------------------------------------
    useEffect(() => {
        setPrevBidDate_1('')
        setPrevBidDate_2('')
        if (getPrevBidDate_res) {
            setPrevBidDate_1(getPrevBidDate_res.prevDate1)
            setPrevBidDate_2(getPrevBidDate_res.prevDate2)
        }
    }, [getPrevBidDate_res])

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        const requireStatus = checkedRequireBidDate() // 必須項目をチェックする
        if (requireStatus) {
            setSearchCount(searchCount+1)
        } else {
            setMessageInfo('require', true)
        }
    }
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today)
        setCondition('')
        setSearchStatus(1)
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
	// eventHandler - 検索Statusの変更
	//-----------------------------------------------
    const handleChange_searchStatus = (checked) => {
        const requireStatus = checkedRequireBidDate() // 必須項目をチェックする
        if (requireStatus) {
            checked ? setSearchStatus(1) : setSearchStatus('')
            setSearchCount(searchCount+1)
        } else {
            setMessageInfo('require', true)
        }
    }
	//-----------------------------------------------
	// eventHandler - 入札開始をクリック
	//-----------------------------------------------
    const handleClick_inBidGroup = async () => {

        const requireStatus = checkedRequire() // 必須項目をチェックする
        if (requireStatus) {
            setIsLoading(true)

            const bidFields = []

            // 登録データのテンプレート
            const tempData = {
                'senmeiGroupCode' : '',
                'senmeiGroup'     : '',
                'senmeiCode'      : '',
                'senmei'          : '',
                'gyoshuCode'      : '',
                'gyoshu'          : '',
                'kgKubun'         : '',
                'nisugata'        : '',
                'kikakuCode'      : '',
                'kikaku'          : '',
                'kgSuryo'         : '',
                'suryo'           : '',
                'yokiCode'        : '',
                'yoki'            : '',
                'memoCode'        : '',
                'memo'            : '',
            }
            let kgSuryoAll = 0
            let suryoAll = 0
            let yokiList = []
            checkedBidList.map(async (checkedBidListId) => {
                
                let bidData = {}
                bidList.map(item => { if (item.id == checkedBidListId) { bidData = item } })
                
                if (bidData.uniqueId) {
                    bidFields.push(`${ bidData.displayGyoshu }`)
                    yokiList.push(bidData)
                }
                kgSuryoAll = Number(kgSuryoAll) + Number(bidData.kgSuryo)
                suryoAll = Number(suryoAll) + Number(bidData.suryo)
                
                tempData.senmeiGroupCode = bidData.senmeiGroupCode
                tempData.senmeiGroup     = bidData.senmeiGroup
                tempData.senmeiCode      = bidData.senmeiCode
                tempData.senmei          = bidData.senmei
                tempData.gyoshuCode      = bidData.gyoshuCode
                tempData.gyoshu          = bidData.gyoshu
                tempData.kgKubun         = bidData.kgKubun
                tempData.nisugata        = bidData.nisugata
                tempData.kikakuCode      = bidData.kikakuCode
                tempData.kikaku          = bidData.kikaku
                tempData.yokiCode        = bidData.yokiCode
                tempData.yoki            = bidData.yoki
                if (bidData.memoCode == 98 || bidData.memoCode == 99) {
                    tempData.memoCode    = bidData.memoCode
                    tempData.memo        = bidData.memo
                }
            })
            tempData.kgSuryo = kgSuryoAll.toFixed(1)
            tempData.suryo   = suryoAll !== Math.floor(suryoAll) ? suryoAll.toFixed(1) : suryoAll.toFixed(0)
            
            // 匹指定入札
            if (tempData.memoCode == 99) {
                tempData.bidMode = 1
            // 箱指定入札
            } else if (tempData.memoCode == 98) {
                tempData.bidMode = 2
            } else {
                tempData.bidMode = 0
            }
            
            // 容器コードと名称は重複を省いてスラッシュでつなげる
            const uniqueYokiList = Object.values(yokiList.reduce((acc, {yokiCode, yoki}) => {
                acc[yokiCode] = { yokiCode, yoki } // codeをキーとしてオブジェクトに格納する
                return acc
            }, {}))
            tempData.yokiCode = uniqueYokiList.map(item => item.yokiCode).join('/')
            tempData.yoki = uniqueYokiList.map(item => item.yoki).join('/')

            setRegisterData(tempData)
            
            // BidGroupを登録する
            if (bidFields.length) {
                await getNextNo() // 新規の場合はbidGroupNoを発行して登録処理を実行
            }
        } else {
            setMessageInfo('require', true)
        }
        return false
    }
	//-----------------------------------------------
	// eventHandler - 共通入札開始をクリック
	//-----------------------------------------------
    const handleClick_inBidGroupCommon = async () => {

        const requireStatus = checkedRequireCommon() // 必須項目をチェックする
        if (requireStatus) {
            setIsLoading(true)
            const bidFields = []

            // 登録データのテンプレート
            const tempData = {
                'senmeiGroupCode' : '',
                'senmeiGroup'     : '',
                'senmeiCode'      : '',
                'senmei'          : '',
                'gyoshuCode'      : '',
                'gyoshu'          : '',
                'kgKubun'         : '',
                'nisugata'        : '',
                'kikakuCode'      : '',
                'kikaku'          : '',
                'kgSuryo'         : '',
                'suryo'           : '',
                'yokiCode'        : '',
                'yoki'            : '',
                'memoCode'        : '',
                'memo'            : '',
            }
            let kgSuryoAll = 0
            let suryoAll = 0
            checkedBidList.map(async (checkedBidListId) => {
                let bidData = {}
                bidList.map(item => { if (item.id == checkedBidListId) { bidData = item } })
                if (bidData.uniqueId) bidFields.push(`${ bidData.displayGyoshu }`)
                kgSuryoAll = Number(kgSuryoAll) + Number(bidData.kgSuryo)
                suryoAll = Number(suryoAll) + Number(bidData.suryo)
                
                tempData.senmeiGroupCode = '999999'
                tempData.senmeiGroup     = '共通'
                tempData.senmeiCode      = '999999'
                tempData.senmei          = '共通'
                tempData.gyoshuCode      = bidData.gyoshuCode
                tempData.gyoshu          = bidData.gyoshu
                tempData.kgKubun         = bidData.kgKubun
                tempData.nisugata        = bidData.nisugata
                tempData.kikakuCode      = bidData.kikakuCode
                tempData.kikaku          = bidData.kikaku
                tempData.yokiCode        = bidData.yokiCode
                tempData.yoki            = bidData.yoki
                if (bidData.memoCode == 98 || bidData.memoCode == 99) {
                    tempData.memoCode    = bidData.memoCode
                    tempData.memo        = bidData.memo
                }
            })
            tempData.kgSuryo = kgSuryoAll.toFixed(1)
            tempData.suryo   = suryoAll !== Math.floor(suryoAll) ? suryoAll.toFixed(1) : suryoAll.toFixed(0)
            
            // 匹指定入札
            if (tempData.memoCode == 99) {
                tempData.bidMode = 1
            // 箱指定入札
            } else if (tempData.memoCode == 98) {
                tempData.bidMode = 2
            } else {
                tempData.bidMode = 0
            }

            setRegisterData(tempData)
            
            // BidGroupを登録する
            if (bidFields.length) {
                await getNextNo() // 新規の場合はbidGroupNoを発行して登録処理を実行
            }
        } else {
            setMessageInfo('require', true)
        }
        return false
    }
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - 入札管理の見出し
	//-----------------------------------------------
    const columnsxBidGroup = [
        { field: 'entryNo',    headerName: 'No',   width: 80, columnSeparatorWidth: 1, type:'number', },
        {
            field: 'groupStatus', headerName: 'ステータス', width: 115,
            renderCell: (params) => (
                <div style={{ 
                    color: params.value === 1 ? 'red' : 'inherit',
                    fontWeight: params.value === 1 ? 'normal' : 'normal'
                }}>
                    {authorityMapping[params.value] || params.value}
                </div>
            ),
        },
        { field: 'startTime',  headerName: '開始',     width: 80, columnSeparatorWidth: 1, },
        { field: 'endTime',    headerName: '終了',     width: 80, columnSeparatorWidth: 1, },
        { field: 'senmei', headerName: '荷主', width: 150, columnSeparatorWidth: 1, },
        { field: 'displayGyoshu', headerName: '品名',    width: 210, columnSeparatorWidth: 1, },
        {
            field: 'kgKubun',
            headerName: 'Kg区分',
            width: 80,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'suryo', headerName: '数量',    width: 80, columnSeparatorWidth: 1, type:'number'},
        { field: 'yoki',    headerName: '容器',  width: 80, columnSeparatorWidth: 1, },
        { field: 'kgSuryo', headerName: 'Kg数',    width: 80, columnSeparatorWidth: 1, type:'number'},
        { field: 'bidPerson',    headerName: '登録者',     width: 120, columnSeparatorWidth: 1, },
    ]
    const authorityMapping = {
        0: '開始待ち',
        1: '入札中',
        8: '開票中',
        9: '入札終了'
    }
	//-----------------------------------------------
    // dataGrid - 未入札一覧の見出し
	//-----------------------------------------------
    const columnsxBidList = [
        { field: 'senmei', headerName: '荷主', width: 140, columnSeparatorWidth: 1, sortable:false, },
        { field: 'displayGyoshu', headerName: '品名',    width: 210, columnSeparatorWidth: 1, sortable:false, },
        {
            field: 'kgKubun',
            headerName: 'Kg区分',
            width: 80, sortable:false,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'suryo', headerName: '数量',    width: 90, columnSeparatorWidth: 1, type:'number', sortable:false},
        { field: 'yoki',    headerName: '容器',  width: 95, columnSeparatorWidth: 1, sortable:false, },
        { field: 'kgSuryo', headerName: 'Kg数',    width: 90, columnSeparatorWidth: 1, type:'number', sortable:false},
        { field: 'displayBiko', headerName: '備考',    width: 180, columnSeparatorWidth: 1, sortable:false, },
    ]
    const unitMapping = {
        1: 'Kg代',
        0: '箱代',
    }
    //-----------------------------------------------
    // dataGrid - 入札一覧の行選択
    //-----------------------------------------------
    const handleClickxBidGroupList = (event) => {
        const uniqueKey = event.row.bidGroupNo
        const groupStatus = event.row.groupStatus
        
        if (authority == 3 && groupStatus != 9) {
            navigate('/bidRegister?bidGroupNo=' + uniqueKey)
        } else {
            navigate('/bidManager?bidGroupNo=' + uniqueKey)
        }
    }
    //-----------------------------------------------
    // dataGrid - 未入札一覧の行選択
    //-----------------------------------------------
    const handleClickxBidList = (event) => {
        if (event.field === '__check__') {
            if (checkedBidList.includes(event.id)) {
                setCheckedBidList(checkedBidList.filter((checkedBidList, index) => (checkedBidList !== event.id)))
            } else {
                setCheckedBidList((checkedBidList)=>[...checkedBidList, event.id])
            }
        }
    }
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = []

        // bidListが1件以上ある場合のみ処理を行う
        const filteredBidList = bidList.filter(item => checkedBidList.includes(item.id))
        if (filteredBidList.length > 1) {
            // bidList内の最初の指定項目を取得
            const firstSenmei    = filteredBidList[0].senmeiGroup
            const firstGyoshu    = filteredBidList[0].gyoshu
            const firstKikaku    = filteredBidList[0].kikaku
            const firstNisugata = filteredBidList[0].nisugata

            // bidList内のすべての指定項目が一致しているかチェック
            const allSenmeiMatch    = filteredBidList.every(item => item.senmeiGroup === firstSenmei)
            const allGyoshuMatch    = filteredBidList.every(item => item.gyoshu === firstGyoshu)
            const allKikakuMatch    = filteredBidList.every(item => item.kikaku === firstKikaku)
            const allNisugataMatch = filteredBidList.every(item => item.nisugata === firstNisugata)

            if (!allSenmeiMatch) errorFields.push('「荷主」')
            if (!allGyoshuMatch) errorFields.push('「魚種」')
            if (!allKikakuMatch) errorFields.push('「規格」')
            if (!allNisugataMatch) errorFields.push('「荷姿」')

            // 引数入札が混在していないかチェック
            const hasHikiMemoCode = filteredBidList.some(item => item.memoCode === 99);
            const hasNonHikiMemoCode = filteredBidList.some(item => item.memoCode !== 99);

            if (hasHikiMemoCode && hasNonHikiMemoCode) {
                errorFields.push('「匹数指定入札」');
            }

            // 箱数入札が混在していないかチェック
            const hasHakoMemoCode = filteredBidList.some(item => item.memoCode === 98);
            const hasNonHakoMemoCode = filteredBidList.some(item => item.memoCode !== 98);

            if (hasHakoMemoCode && hasNonHakoMemoCode) {
                errorFields.push('「箱数指定入札」');
            }
        }
    
        if (errorFields.length) {
            const text = errorFields.join('') + 'が同一のものを指定してください'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequireCommon = () => {
        const errorFields = []

        // bidListが1件以上ある場合のみ処理を行う
        const filteredBidList = bidList.filter(item => checkedBidList.includes(item.id))
        if (filteredBidList.length > 1) {
            // bidList内の最初の指定項目を取得
            const firstGyoshu    = filteredBidList[0].gyoshu
            const firstKikaku    = filteredBidList[0].kikaku
            const firstNisugata = filteredBidList[0].nisugata

            // bidList内のすべての指定項目が一致しているかチェック
            const allGyoshuMatch    = filteredBidList.every(item => item.gyoshu === firstGyoshu)
            const allKikakuMatch    = filteredBidList.every(item => item.kikaku === firstKikaku)
            const allNisugataMatch = filteredBidList.every(item => item.nisugata === firstNisugata)

            if (!allGyoshuMatch) errorFields.push('「魚種」')
            if (!allKikakuMatch) errorFields.push('「規格」')
            if (!allNisugataMatch) errorFields.push('「荷姿」')
        }
    
        if (errorFields.length) {
            const text = errorFields.join('') + 'が同一のものを指定してください'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequireBidDate = () => {
        const errorFields = []
        
        const numericEntryDate = dateToString(entryDate)
        
        if (authority == 3 && (numericEntryDate < prevBidDate_2)) errorFields.push('参照可能な入札日')
    
        if (errorFields.length) {
            const text = '過去の入札情報の参照は前回と前々回分まで可能です'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }))
    }
    //===============================================
    // Css
    //===============================================
    
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" />
            <div className='bidGroup bodyContens'>
                <TitleBar title={title} />
                <div className='mainContents'>
                    <Frame classname="frame" title="入札検索">
                        <div style={{display:'flex'}}>
                            <div>
                            <BidSearchForm
                                targetDateId       = "bidGroup_targetDate"
                                targetDateValue    = { entryDate }
                                targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                keywordId          = "bidGroup_condition"
                                keywordValue       = { condition }
                                keywordOnChange    = { (e) => setCondition(e.target.value) }
                                handleSearch       = { () => handleClick_search() }
                                handleSearchClear  = { () => handleClick_search_clear() }
                            />
                            </div>
                            <div style={{marginLeft:'20px'}}>
                                <CustomCheckbox
                                    defaultChecked = { searchStatus }
                                    onChange       = { (e) => handleChange_searchStatus(e.target.checked) }
                                    label          = "入札未実施のみ"
                                />
                            </div>
                        </div>
                        <div style={{marginTop:'10px'}}>
                            <CustomDataGrid
                                getRowClassName={(params) => {
                                    let className = ''
                                    if (params.indexRelativeToCurrentPage % 2 === 0) {
                                        className += 'even '
                                    } else {
                                        className += 'odd '
                                    }
                                    if (params.row.groupStatus === 1) {
                                        className += 'cell_inBidding'
                                    }
                                    return className.trim() // クラス名の文字列の前後の余分な空白を削除
                                }}
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { bidGroupList }
                                columns                 = { columnsxBidGroup }
                                sx                      = { {height:authorityHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                disableColumnMenu       = {true}
                                onCellClick             = {(event) => handleClickxBidGroupList(event)}
                                loading                 = { searchData_bidList_Loading }
                            />
                        </div>
                    </Frame>
                    <div style={{ display: authority == 3 ? 'none' : 'block' }}>
                        <Frame classname="frame" title="未登録の明細一覧">
                            <div style={{display:'flex'}}>
                                <div style={{marginBottom:'8px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff', backgroundColor:'#ff0000'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleUpIcon />}
                                        onClick   = {() => setMessageInfo('confirm', true) }
                                    >
                                    入札開始
                                    </Button>
                                </div>
                                <div style={{marginBottom:'8px', marginLeft:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff', }}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleUpIcon />}
                                        onClick   = {() => setMessageInfo('confirm_common', true) }
                                    >
                                    共通入札開始
                                    </Button>
                                </div>
                            </div>
                            <CustomDataGrid
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { bidList }
                                columns                 = { columnsxBidList }
                                sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                checkboxSelection
                                disableColumnMenu          = {true}
                                onCellClick                = {(event) => handleClickxBidList(event)}
                                onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedBidList(newSelectionModel) }}
                                rowSelectionModel          = {checkedBidList}
                                loading                    = { searchData_Loading }
                            />
                        </Frame>
                    </div>
                </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "入札を開始しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <div>
                    <Dialog open={messageState.confirm} onClose={() => setMessageInfo('confirm', false)}>
                        <DialogContent>
                            <DialogContentText>
                            入札を開始します。よろしいですか？
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setMessageInfo('confirm', false)} color="primary">キャンセル</Button>
                            <Button onClick={() => handleClick_inBidGroup()} color="primary" disabled={isLoading}>続行</Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div>
                    <Dialog open={messageState.confirm_common} onClose={() => setMessageInfo('confirm_common', false)}>
                        <DialogContent>
                            <DialogContentText>
                            共通入札を開始します。よろしいですか？
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setMessageInfo('confirm_common', false)} color="primary">キャンセル</Button>
                            <Button onClick={() => handleClick_inBidGroupCommon()} color="primary" disabled={isLoading}>続行</Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        </>
    )
}
export default BidGroup

  
